import React from 'react';
import { Link } from 'react-router-dom';
import { Lock, Home } from 'lucide-react';

const SectionUnavailablePage = ({ section }) => {
  return (
    <div className="min-h-screen pt-24 pb-32 px-6 flex items-center justify-center" data-testid="section-unavailable-page">
      <div className="text-center max-w-md">
        <div className="w-20 h-20 mx-auto mb-6 rounded-full bg-[#D4AF37]/10 flex items-center justify-center">
          <Lock size={40} className="text-[#D4AF37]" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-4" style={{ fontFamily: 'Syne' }}>
          {section} <span className="gradient-text">Unavailable</span>
        </h1>
        <p className="text-neutral-400 mb-8">
          This section is currently not available. Please check back later or explore other parts of the site.
        </p>
        <Link to="/" className="btn-primary inline-flex items-center gap-2" data-testid="back-home-btn">
          <Home size={18} />
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default SectionUnavailablePage;
